import axios from '@/utils/request'

const orderHoldUrl = '/data/user/agent/orderHold'
const orderHold = async (body) => {
  const { data } = await axios.post(orderHoldUrl, body)
  return data.data
}

const orderHistoryUrl = '/data/user/agent/orderHistory'
const orderHistory = async (body) => {
  const { data } = await axios.post(orderHistoryUrl, body)
  return data.data
}

const needLoginUrl = []

export default {
  needLoginUrl,
  orderHold,
  orderHistory,
}
